var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFitlerPlusBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.08398 2.41691L6.08398 11.5836C6.08398 12.0898 6.49439 12.5002 7.00065 12.5002C7.50691 12.5002 7.91732 12.0898 7.91732 11.5836L7.91732 2.41691C7.91732 1.91065 7.50691 1.50024 7.00065 1.50024C6.49439 1.50024 6.08398 1.91065 6.08398 2.41691Z",
    fill: "#3E97FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5833 6.0835H2.41667C1.91041 6.0835 1.5 6.4939 1.5 7.00016C1.5 7.50642 1.91041 7.91683 2.41667 7.91683H11.5833C12.0896 7.91683 12.5 7.50642 12.5 7.00016C12.5 6.4939 12.0896 6.0835 11.5833 6.0835Z",
    fill: "#3E97FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitlerPlusBlue);
export default __webpack_public_path__ + "static/media/fitler-plus-blue.bafe4c442c1b44a3350dea355105a764.svg";
export { ForwardRef as ReactComponent };